import { ArrowRight, CloneIcon, SaveIcon } from "../icons";
import { CancelButton } from "./CancelButton";
import { ChoiceList } from "./ChoiceList";
import { Choice } from "./ChoiceList.types";
import { Modal } from "./Modal";
import { UnsavedChangesModalProps } from "./UnsavedChangesModal.types";

const DefaultMessage =
  "You have unsaved changes. Do you want to save them before leaving this page?";

/** Asks what to do with unsaved work before the page is left. */
export function UnsavedChangesModal({
  message = DefaultMessage,
  isSubmitting = false,
  onCancel,
  onContinueWithoutSaving,
  onSaveAndContinue,
  onSaveAsNewView,
  saveDescription = "Update this view, then leave the page",
  discardDescription = "Discard your changes and leave the page",
}: UnsavedChangesModalProps) {
  const choices: Choice[] = [
    {
      title: "Save and continue",
      description: saveDescription,
      icon: SaveIcon,
      iconClassName: "text-primary",
      onClick: onSaveAndContinue,
      showSpinner: isSubmitting,
    },
    ...(onSaveAsNewView
      ? [
          {
            title: "Save as new view",
            description: "Keep this view as it was and save a copy",
            icon: CloneIcon,
            iconClassName: "text-primary",
            onClick: onSaveAsNewView,
          },
        ]
      : []),
    {
      title: "Continue without saving",
      description: discardDescription,
      icon: ArrowRight,
      iconClassName: "text-danger",
      onClick: onContinueWithoutSaving,
    },
  ];

  return (
    <Modal title="Unsaved changes" onClose={onCancel}>
      <div className="modal-body">
        <p>{message}</p>
        <ChoiceList choices={choices} disabled={isSubmitting} />
      </div>
      <div className="modal-footer d-block">
        <CancelButton onClick={onCancel} />
      </div>
    </Modal>
  );
}

export default UnsavedChangesModal;
